import { render, staticRenderFns } from "./operadora-contratada.vue?vue&type=template&id=523f3c62&scoped=true"
import script from "./operadora-contratada.vue?vue&type=script&lang=js"
export * from "./operadora-contratada.vue?vue&type=script&lang=js"
import style0 from "./operadora-contratada.vue?vue&type=style&index=0&id=523f3c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f3c62",
  null
  
)

export default component.exports